"use client";

import { ThemeProvider } from "next-themes";

/**
 * The kit's providers. `storageKey` names where the light or dark choice is remembered (one key
 * per brand, so two portals on one machine do not share it); next-themes' own key is the default.
 */
const Providers = ({ children, storageKey }: { children: React.ReactNode; storageKey?: string }) => {
    return <ThemeProvider disableTransitionOnChange storageKey={storageKey}>{children}</ThemeProvider>;
};

export default Providers;
